export default __webpack_public_path__ + "static/media/no-search-results-icon.70a850be.svg";